module.exports = "input.ng-invalid, textarea.ng-invalid {\n    border-color: red;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/users/user-editor.component.css
// module id = ./src/app/admin/users/user-editor.component.css
// module chunks = main